import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { auth } from '../../api/client';
import { useAuth } from '../../contexts/AuthContext';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';

export default function ChangePassword() {
  const { login, logout, user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.newPassword.length < 8) {
      setError('Fjalëkalimi i ri duhet të ketë së paku 8 karaktere.');
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setError('Fjalëkalimet nuk përputhen.');
      return;
    }

    setLoading(true);
    try {
      const res = await auth.changePassword({
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      });
      login(res.data);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Gabim gjatë ndryshimit të fjalëkalimit.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f1f5f9' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 40, width: '100%', maxWidth: 420, boxShadow: '0 4px 24px #00000015', border: '1px solid #e5e7eb' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ width: 48, height: 48, background: '#3b82f6', borderRadius: 12, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
            <ShieldCheck color="#fff" size={24} />
          </div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#111827' }}>Ndrysho Fjalëkalimin</h1>
          <p style={{ margin: '6px 0 0', color: '#6b7280', fontSize: 13.5, lineHeight: 1.5 }}>
            Mirë se vini{user?.firstName ? `, ${user.firstName}` : ''}! Për arsye sigurie, duhet të vendosni një fjalëkalim të ri para se të vazhdoni.
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {error && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '10px 12px', color: '#dc2626', fontSize: 13 }}>{error}</div>}
          <Input label="Fjalëkalimi i përkohshëm" type="password" value={form.currentPassword} onChange={set('currentPassword')} required placeholder="Nga email-i juaj" />
          <Input label="Fjalëkalimi i ri" type="password" value={form.newPassword} onChange={set('newPassword')} required placeholder="Min. 8 karaktere" />
          <Input label="Konfirmo fjalëkalimin e ri" type="password" value={form.confirmPassword} onChange={set('confirmPassword')} required placeholder="Përsërite fjalëkalimin" />
          <Button type="submit" loading={loading} size="lg" style={{ width: '100%', justifyContent: 'center', marginTop: 4 }}>
            Ruaj dhe vazhdo
          </Button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 18, fontSize: 13, color: '#6b7280' }}>
          <button onClick={logout} style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}>
            Dil nga llogaria
          </button>
        </p>
      </div>
    </div>
  );
}
